import actions from "@/store/actions/earnCoinsAction";
import mutations from "@/store/mutations/earnCoinsMutation";
import getters from "@/store/getters/earnCoinsGetter";
/**
 * [GX] GX Earn Conis
 */
export default {
  state: {
    feeds: []
  },
  mutations,
  actions,
  getters
};
